require("whatwg-fetch");
module.exports = self.fetch.bind(self);
